import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

const StyledTabs = styled(Tabs)({
  minHeight: 44,
  "& .MuiTabs-indicator": {
    height: 3,
    borderRadius: 3,
    backgroundColor: "#070639",
  },
});

const StyledTab = styled((props: React.ComponentProps<typeof Tab>) => (
  <Tab disableRipple {...props} />
))({
  minHeight: 44,
  textTransform: "none",
  fontWeight: 600,
  fontSize: 14,
  padding: "10px 16px",
  "&.Mui-selected": {
    color: "#070639",
  },
});

export default function MuiTabs({ 
  items = [], 
  selectedTab = "", 
  onTabChange = (_: string) => {}, 
  ariaLabel = "Tabs" 
}) {
  const [value, setValue] = React.useState(selectedTab);

  React.useEffect(() => {
    setValue(selectedTab);
  }, [selectedTab]);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
    onTabChange(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <StyledTabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label={ariaLabel || "Tabs"}
      >
        {items.map((item, index) => (
          <StyledTab
            key={index}
            value={item.value}
            label={item.label}
            id={`app-tab-${index}`}
            aria-controls={`app-tabpanel-${index}`}
          />
        ))}
      </StyledTabs>
    </Box>
  );
}
